import {div} from '@xh/hoist/cmp/layout';
import {ElementSpec} from '@xh/hoist/core';
import './Toolbar.scss';
import {button, ButtonProps} from '@xh/hoist/desktop/cmp/button';
import {select, SelectProps} from '@xh/hoist/desktop/cmp/input';
import {menuButton, MenuButtonProps} from '@xh/hoist/desktop/cmp/menu';
import classNames from 'classnames';

export function toolbarButtonSeparator(omit?: boolean) {
    return div({className: 'toolbar-button-separator', omit});
}

export function compactToolbarButton(
    props: ElementSpec<ButtonProps>
): React.ReactElement<ButtonProps, any> {
    return button({className: 'square-button', ...props});
}

export function compactToolbarMenuButton(props: ElementSpec<MenuButtonProps>): React.ReactElement<MenuButtonProps, any> {
    const {popoverProps, ...rest} = props;
    return menuButton({
        className: 'square-button',
        ...rest,
        popoverProps: {...popoverProps, targetProps: {className: 'square-button-target', ...popoverProps?.targetProps}}
    });
}

export function compactToolbarSelect(
    props: ElementSpec<SelectProps>
): React.ReactElement<SelectProps, any> {
    return select({
        enableFilter: false,
        ...props,
        className: classNames('compact-select', props.className)
    });
}
